import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip 
    {...props} 
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -10],
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#333',
    fontSize: '14px',
    padding: '8px 12px',
  },
  '& .MuiTooltip-arrow': {
    color: '#333',
  },
}));

const globalStyles = {
    grid: {
        //boxShadow: 6,
        '& .MuiDataGrid-row:hover': {
            //backgroundColor: '#e1f1ff',
            //boxShadow: '0px 5px 10px #ccc, 0px -5px 10px #ccc'
        },
        '& .MuiDataGrid-cell': {
            // borderRight: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            fontSize: '11px'
        },
        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-footerContainer, .MuiDataGrid-columnHeaders': {
            // backgroundColor: '#f0f0f0'
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
            fontSize: '13px',
            color: '#666'
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '1em',
            height: '.8em',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: '#f9f9f9',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        '& .MuiTablePagination-selectLabel, .MuiInputBase-root, .MuiTablePagination-displayedRows': {
            fontSize: '12px'
        }
    },
    mainMenu: {
        "&.Mui-selected": {
            backgroundColor: "#2b2b2b",
            boxShadow: '0px 2px 10px #111, 0px -2px 10px #222',
            color: "#f0f0f0"
        },
        "&.Mui-focusVisible": {
            backgroundColor: "#2b2b2b",
            boxShadow: '0px 2px 10px #111, 0px -2px 10px #222',
            color: "#f0f0f0",
            fontWeight: "light"
        },
        ":hover": {
            backgroundColor: "#2b2b2b",
            boxShadow: '0px 2px 10px #111, 0px -2px 10px #222',
            color: "#f0f0f0"
        },
        '& .MuiListItemIcon-root': {
        minWidth: '40px'  // Default is 56px, reducing this closes the gap
    }
    },
    mainFullWidth: {
        flexGrow: 1,
        padding: 0,
        marginTop: '64px',
        backgroundColor: '#f5f5f5',
        minHeight: 'calc(100vh - 64px)',
        overflow: 'auto',
    }
}

export default globalStyles